import { Controller } from '@hotwired/stimulus';
import Pagy from '../pagy.mjs';

export default class extends Controller {
  static values = {
    targetSelector: String,
    onlyScrollUp: Boolean,
  };

  connect() {
    Pagy.init(this.element);
    this.element.addEventListener('click', this.#handleClick);
  }

  disconnect() {
    this.element.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const paginationLink = event.target.closest('.pagination span.page a, .pagination .page-item a');

    if (!paginationLink) return;

    setTimeout(() => this.#performScroll(), 100);
  }

  #performScroll() {
    if (!this.#hasValidTarget()) return;

    const target = document.querySelector(this.targetSelectorValue);
    if (!target) return;

    const currentPosition = window.scrollY;
    const headerHeight = document.querySelector('header')?.clientHeight || 0;
    const targetPosition = target.getBoundingClientRect().top + currentPosition - headerHeight;

    if (!this.onlyScrollUpValue || currentPosition > targetPosition) {
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  }

  #hasValidTarget() {
    return this.hasTargetSelectorValue && this.targetSelectorValue.trim();
  }
}
